module.exports = __webpack_public_path__ + "static/img/newfabao.b128959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newfabao.png
// module id = ZKkY
// module chunks = 97